
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@truefit/http-utils';

const useEnqueueClipForExportMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (clipId: number) => {
      await post(`/v1.0/clips/${clipId}/export`, undefined);
    },
    gcTime: 0,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clips'] });
    }
  });
}

export default useEnqueueClipForExportMutation;
